import { initWidget } from '@embedded-banking-fundr/pbl';
import '@embedded-banking-fundr/pbl/style.css';
import './rabobank-pbl-custom.css';
import financieren from './assets/financieren.png';
function App() {
  const contactDetails = {
    name: 'John',
    surname: 'Doe',
    phone: '0612345678',
    email: 'john.doe@example.com',
  };
  const contact = JSON.stringify(contactDetails);
  initWidget({
    identifier: 'gEkzRWM4zKQCWojzNKyvZjuwk6BzlNZW24',
    partner: 'SNELFINANCIEREN',
  });
  return (
    <div className="App">
      <div className='sitelogo'>
      <img
        src={financieren}
        alt="Rabobank Logo"
        className="rabobank-logo"
      />
      </div>
    <rabobank-pbl
      kvk-number=""
      loan-goal="INVENTORY"
      mode="production"
    />
    </div>
  );
}
export default App;